import { z } from "zod"
import { CreateInvitationDtoSchema } from "@mimber/schema"

/**
 * Form schema that extends the DTO schema
 * Matches the API requirements for creating invitations
 */
export const sendInvitationSchema = CreateInvitationDtoSchema

/**
 * Org-admin invite variant: requires organizationRoleId, since the whole
 * point of this mode is granting an elevated role.
 */
export const sendOrgAdminInvitationSchema = CreateInvitationDtoSchema.extend({
  organizationRoleId: z.string().uuid(),
})

/**
 * Form data type - matches the schema output
 */
export type SendInvitationData = z.output<typeof sendInvitationSchema>
